/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyMobileOrderCallingScreenMessageTypename = "PharmacyMobileOrderCallingScreenMessage" as const;

/**
 *
 * @export
 * @interface PharmacyMobileOrderCallingScreenMessage
 */
export interface PharmacyMobileOrderCallingScreenMessage {
  /**
   *
   * @type {string}
   * @memberof PharmacyMobileOrderCallingScreenMessage
   */
  message: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyMobileOrderCallingScreenMessage
   */
  readonly __typename?: string;
}

export function PharmacyMobileOrderCallingScreenMessageFromJSON(json: any): PharmacyMobileOrderCallingScreenMessage {
  return PharmacyMobileOrderCallingScreenMessageFromJSONTyped(json, false);
}

export function PharmacyMobileOrderCallingScreenMessageFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyMobileOrderCallingScreenMessage {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyMobileOrderCallingScreenMessageTypename,

    message: json["message"],
  };
}

export function PharmacyMobileOrderCallingScreenMessageToJSON(
  object?: PharmacyMobileOrderCallingScreenMessage | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    message: value.message,
  };
}
